"use client"
import React, { useEffect } from 'react';
import { useLoaderLogic } from './loader.func';
import styles from './Loader.module.css';

const Loader = () => {
  const { isVisible } = useLoaderLogic();

  // Disable/Enable scroll based on loader visibility
  useEffect(() => {
    if (isVisible) {
      // Disable scroll when loader is visible
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    } else {
      // Re-enable scroll when loader disappears
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    }

    // Cleanup function to ensure scroll is re-enabled
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`${styles.Loader__MainContainer} loader-container`}>
      <div className={styles.Loader__MainContainer_TextPart}>
        <h1 className="text">trusted</h1>
        <h1 className="text">natural</h1>
        <h1 className="text">authentic</h1>
      </div>
    </div>
  );
};

export default Loader;
